import { GetColumnsWithGroupField } from "../models/windows/GetColumnsWithGroup";
import { getParentFieldMappings } from "./StoresAccountHelper";

// Find dependent objects recursively (DFS)
export function getDependentObjects(
  name: string,
  dependencyMap: Map<string, string[]>
) {
  const affectedObjects = new Set<string>();
  const fields = getParentFieldMappings(name);
  fields.forEach((field) => {
    if (dependencyMap.has(field)) {
      dependencyMap.get(field)?.forEach((childId) => {
        if (!affectedObjects.has(childId)) {
          affectedObjects.add(childId);
          const subChildren = getDependentObjects(childId, dependencyMap);
          subChildren.forEach(affectedObjects.add, affectedObjects);
        }
      });
    }
  });

  return affectedObjects;
}

//Create Dependency Map
export function getCascadeDependencyMap(fields: GetColumnsWithGroupField[]) {
  const dependencyMap = new Map<string, string[]>();
  fields.forEach((item) => {
    if (item.CascadeParent) {
      if (!dependencyMap.has(item.CascadeParent)) {
        dependencyMap.set(item.CascadeParent, []);
      }
      dependencyMap.get(item.CascadeParent)?.push(item.PropertyName ?? "");
    } else if (item.CascadeChild && item.PropertyName) {
      const child = fields.find((f) =>
        getParentFieldMappings(item.CascadeChild ?? "").some(
          (c) => c.toLowerCase() === f.PropertyName?.toLowerCase()
        )
      );
      if (!dependencyMap.has(item.PropertyName)) {
        dependencyMap.set(item.PropertyName, []);
      }
      dependencyMap.get(item.PropertyName)?.push(child?.PropertyName ?? "");
    }
  });

  return dependencyMap;
}
